const availableJobCategories = [
    {
        label: 'Casting',
        code: 'casting'
    },
    {
        label: 'Apoio para Eventos',
        code: 'event_support'
    },
    {
        label: 'Bares e Restaurantes',
        code: 'bars_restaurants'
    },
    {
        label: 'Mestres de Cerimônia',
        code: 'master_of_ceremonies'
    }
]

export default availableJobCategories